import React, { useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import heic2any from "heic2any";
import imageCompression from "browser-image-compression";
import "./Image.scss";
import { getFileInfo } from "../../../utils/helper";
import commonImages from "../../../assets";

const HeicThumb = ({ url }) => {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    (async () => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const converted = await heic2any({
          blob,
          toType: "image/jpeg",
          quality: 0.8,
        });
        const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
        const jpegFile = new File([jpegBlob], "image.jpg", {
          type: "image/jpeg",
        });
        const compressedFile = await imageCompression(jpegFile, {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        });
        objectUrl = URL.createObjectURL(compressedFile);
        if (!cancelled) setSrc(objectUrl);
      } catch (error) {
        if (!cancelled) setSrc(commonImages?.noimage);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return src ? (
    <img src={src} alt="No Files" className="img" />
  ) : (
    <CircularProgress size={20} />
  );
};

const Thumbs = ({
  files,
  handleCloseFile,
  imageUrl = "",
  deleteImageURL,
  isLoader,
}) => {
  const imageUrlConvertArray =
    imageUrl && imageUrl.length > 0 ? imageUrl?.split("|") : "";

  const uniqueImageUrls = [...new Set(imageUrlConvertArray)];

  return (
    <div className="overideImage">
      <div className="thumbContainer">
        {uniqueImageUrls &&
          uniqueImageUrls?.length > 0 &&
          uniqueImageUrls?.map((url, index) => {
            const fileInfo = getFileInfo(url);
            const isHeic =
              fileInfo?.fileExtension === "heic" ||
              fileInfo?.fileExtension === "heif";

            return (
              <div className="imgBox" key={index}>
                <div
                  className="removeIcon"
                  onClick={(i) => deleteImageURL(url, index)}
                >
                  X
                </div>
                {isHeic ? (
                  <HeicThumb url={url} />
                ) : (
                  <img
                    src={
                      fileInfo?.isPreviewUnsupported
                        ? commonImages?.noimage
                        : url
                    }
                    alt="No Files"
                    className="img"
                  />
                )}
                <div className="fileName"></div>
              </div>
            );
          })}
        {/* {isLoader && <p>Loading...</p>} */}
        {isLoader && (
          <Stack className="loaderDropBox" spacing={2} direction="row">
            <CircularProgress color="success" />
          </Stack>
        )}
      </div>
    </div>
  );
};

export default Thumbs;
